import { useManagedAnimations } from '@artica/hooks';
import {
  LoopOnce,
  AnimationClip,
  AnimationMixer,
  InterpolateLinear,
  NumberKeyframeTrack,
} from 'three';

export const createNumericAnimation = (name, times, values, duration, property) => {
  const track = new NumberKeyframeTrack(property, times, values, InterpolateLinear);

  return new AnimationClip(null, duration, [track]);
};

export const createMixer = (object, animations) => {
  const mixer = new AnimationMixer(object);
  mixer.update = useManagedAnimations.update;

  animations.forEach(val => {
    mixer.clipAction(val).setLoop(LoopOnce);
    mixer.clipAction(val).clampWhenFinished = false;
  });

  // eslint-disable-next-line no-underscore-dangle
  const duration = mixer._actions.reduce((memo, action) => {
    const { duration } = action.getClip();
    return Math.max(duration, memo);
  }, 0);

  return {
    mixer,
    duration,
  };
};
